<template>
  <div id="contenedor-imagenes-carouseles">
    <v-carousel
      :value="currentIndex"
      hide-delimiters
      @change="cambioDeImagen">
      <template
        v-for="(imagen, index) in imagenes">
        <template>
          <v-carousel-item
            :key="`imagen-${index}`"
            :src="imagen"
            max-width="100%"
            max-heigth="100%"
            contain
            aspect-ratio="16/9"
            reverse-transition="fade-transition"
            transition="fade-transition">
          </v-carousel-item>
        </template>
      </template>
    </v-carousel>
  </div>
</template>

<script>
export default {
  name: 'ImagenCarousels',
  props: {
    imagenes: {
      type: Array,
      required: true,
    },
    currentIndex: {
      type: Number,
      required: false,
      default: 0,
    },
  },
  data() {
    return {
      wup: this.currentIndex,
    };
  },
  methods: {
    cambioDeImagen(e) {
      const imagen = this.imagenes[e];
      this.$emit('cambioDeImagen', imagen);
    },
  },
};
</script>

<style lang="scss">

</style>
